import React, { lazy } from 'react';
interface PaymentMethodsProps {
  className?: string;
  align?: 'center' | 'start';
}
/**
 * Accepted payment methods strip: Mercado Pago, Visa, Mastercard, Amex.
 * Brand marks are rendered as styled badges (no external logo assets needed).
 */
export function PaymentMethods({
  className = '',
  align = 'center'
}: PaymentMethodsProps) {
  return <div className={className} data-id="element-668">
      <div className={`flex items-center gap-1.5 ${align === 'center' ? 'justify-center' : 'justify-start'} mb-2`} data-id="element-669">
        <span className="text-[10px] sm:text-xs font-bold text-ink-light uppercase tracking-wider" data-id="element-670">
          Medios de pago disponibles
        </span>
      </div>
      <div className={`flex flex-wrap items-center gap-2 ${align === 'center' ? 'justify-center' : 'justify-start'}`} data-id="element-671">
        {/* Mercado Pago */}
        <div className="h-7 px-2 rounded-md bg-white border border-ink/10 flex items-center shadow-sm" data-id="element-672">
          <img src="https://cdn.magicpatterns.com/uploads/c2VAA5hWyGZEFp1y2m831X/Captura_de_pantalla_2026-05-25_174501.png" alt="Mercado Pago" className="h-4 w-auto object-contain" loading="lazy" data-id="element-673" />
        </div>
        {/* Visa */}
        <div className="h-7 px-2.5 rounded-md bg-white border border-ink/10 flex items-center shadow-sm" data-id="element-674">
          <span className="text-[#1A1F71] font-extrabold italic text-sm tracking-tight leading-none" data-id="element-675">
            VISA
          </span>
        </div>
        {/* Mastercard */}
        <div className="h-7 px-2.5 rounded-md bg-white border border-ink/10 flex items-center gap-1.5 shadow-sm" data-id="element-676">
          <span className="relative flex items-center" aria-hidden="true" data-id="element-677">
            <span className="w-3.5 h-3.5 rounded-full bg-[#EB001B]" data-id="element-678" />
            <span className="w-3.5 h-3.5 rounded-full bg-[#F79E1B] -ml-1.5 mix-blend-multiply" data-id="element-679" />
          </span>
          <span className="text-ink font-bold text-[10px] tracking-tight leading-none" data-id="element-680">
            mastercard
          </span>
        </div>
        {/* American Express */}
        <div className="h-7 px-2.5 rounded-md bg-[#006FCF] flex items-center shadow-sm" data-id="element-681">
          <span className="text-white font-extrabold text-[10px] tracking-tight leading-none" data-id="element-682">
            AMEX
          </span>
        </div>
      </div>
    </div>;
}